import { Component, Input, OnInit } from "@angular/core";
import { ReportEntryCategory } from "../../../server/enums/report-entry-category.enum";
import { ReportService } from "../../../api/services/report.service";
import { ReportEntryDto } from "../../../api/models/report-entry-dto";

@Component({
    selector: "app-reports-list",
    templateUrl: "./reports-list.component.html",
    styleUrl: "./reports-list.component.scss",
    standalone: false
})
export class ReportsListComponent implements OnInit {
  @Input() id: number;
  @Input() type: ReportEntryCategory;
  reports: ReportEntryDto[] = [];
  protected readonly ReportEntryCategory = ReportEntryCategory;

  constructor(private reportService: ReportService) {}

  ngOnInit(): void {
    this.reportService.reportControllerGetClientReports({ clientId: this.id, type: this.type }).subscribe((reports) => {
      this.reports = reports;
    });
  }
}
